<div class="admin-server-table-wrapper" [ngClass]="tableWrapperClass">
  <table class="table admin-server-table align-middle mb-0" [ngClass]="tableClass">
    <thead>
      <tr>
        <th
          *ngFor="let column of columns; trackBy: trackByColumn"
          scope="col"
          [ngClass]="column.headerClass"
        >
          <button
            *ngIf="column.sortable && column.sortKey; else staticHeaderTpl"
            type="button"
            class="admin-server-table__sort-btn"
            (click)="onToggleSort(column)"
          >
            <span>{{ column.header }}</span>
            <span class="admin-server-table__sort-indicator">{{ sortLabel(column) }}</span>
          </button>
          <ng-template #staticHeaderTpl>
            <span>{{ column.header }}</span>
          </ng-template>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngIf="loading">
        <td [attr.colspan]="columns.length" class="admin-server-table__status-cell">
          Cargando registros...
        </td>
      </tr>

      <tr *ngFor="let row of rows; trackBy: trackByRowInternal">
        <td
          *ngFor="let column of columns; trackBy: trackByColumn"
          [ngClass]="column.cellClass"
          [attr.title]="getCellTitle(row, column)"
        >
          <ng-container *ngIf="column.cellTemplate; else defaultCellTpl">
            <ng-container
              *ngTemplateOutlet="column.cellTemplate; context: getCellTemplateContext(row, column)"
            ></ng-container>
          </ng-container>
          <ng-template #defaultCellTpl>
            {{ getCellDisplay(row, column) }}
          </ng-template>
        </td>
      </tr>

      <tr *ngIf="!loading && !hasData">
        <td [attr.colspan]="columns.length" class="admin-server-table__status-cell">
          {{ emptyMessage }}
        </td>
      </tr>
    </tbody>
  </table>
</div>

<div *ngIf="pagination.total > 0" class="admin-server-table-pagination">
  <div class="admin-server-table-pagination__meta">
    Mostrando {{ pagination.pageStartIndex }}&ndash;{{ pagination.pageEndIndex }} de {{ pagination.total }}
    {{ summaryNoun }}
  </div>
  <div class="admin-server-table-pagination__controls">
    <label class="admin-server-table-pagination__size">
      <span>Filas por página</span>
      <select
        class="form-select form-select-sm"
        [ngModel]="pagination.pageSize"
        (ngModelChange)="onPageSizeChange($event)"
        [disabled]="loading"
      >
        <option *ngFor="let size of pagination.pageSizeOptions" [ngValue]="size">{{ size }}</option>
      </select>
    </label>

    <nav class="admin-server-table-pagination__nav" aria-label="Paginación tabla">
      <button
        type="button"
        class="admin-server-table-pagination__btn admin-server-table-pagination__btn--edge"
        (click)="goToFirstPage()"
        [disabled]="loading || !pagination.hasPreviousPage"
      >
        Primero
      </button>
      <button
        type="button"
        class="admin-server-table-pagination__btn admin-server-table-pagination__btn--edge"
        (click)="goToPreviousPage()"
        [disabled]="loading || !pagination.hasPreviousPage"
      >
        Anterior
      </button>

      <ng-container *ngFor="let item of paginationItems; trackBy: trackByPaginationItem">
        <button
          *ngIf="item !== 'ellipsis'; else ellipsisTpl"
          type="button"
          class="admin-server-table-pagination__btn"
          [class.admin-server-table-pagination__btn--active]="item === pagination.page"
          (click)="goToPage(item)"
          [disabled]="loading || item === pagination.page"
        >
          {{ item }}
        </button>
        <ng-template #ellipsisTpl>
          <span class="admin-server-table-pagination__ellipsis">…</span>
        </ng-template>
      </ng-container>

      <button
        type="button"
        class="admin-server-table-pagination__btn admin-server-table-pagination__btn--edge"
        (click)="goToNextPage()"
        [disabled]="loading || !pagination.hasNextPage"
      >
        Siguiente
      </button>
      <button
        type="button"
        class="admin-server-table-pagination__btn admin-server-table-pagination__btn--edge"
        (click)="goToLastPage()"
        [disabled]="loading || !pagination.hasNextPage"
      >
        Último
      </button>
    </nav>
  </div>
</div>
